import { useSiteSettings } from "@/hooks/useSiteSettings";

export const BrandMark = ({ compact = false }) => {
  const { logo } = useSiteSettings();
  return (
    <a href="#top" data-testid="header-logo-slot" aria-label="RamVilas Kitchen & Hardware Store — home"
       className="group flex items-center gap-3 rounded-2xl border border-[#C59B27]/40 bg-[#FBF3DC]/70 py-1.5 pl-3 pr-1.5 transition-colors duration-300 hover:bg-[#F7EACB]">
      <span className="flex flex-col items-end leading-none text-right">
        <span className="shimmer-name font-display font-bold text-base sm:text-xl tracking-wide" data-testid="header-store-name">
          RamVilas
        </span>
        {!compact && (
          <span className="mt-1 text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.18em] text-[#8B5A2B]">
            Kitchen &amp; Hardware
          </span>
        )}
      </span>
      <span className="logo-glow grid h-14 w-14 sm:h-16 sm:w-16 shrink-0 place-items-center overflow-hidden rounded-full bg-white ring-1 ring-[#C59B27]/50 transition-transform duration-300 group-hover:scale-[1.04]">
        {logo ? (
          <img src={logo} alt="RamVilas logo" className="h-full w-full object-contain p-0.5" data-testid="header-logo-image" />
        ) : (
          <span className="grid h-full w-full place-items-center bg-[#1B4332] font-display text-lg sm:text-xl font-bold text-[#F3DB8C]" data-testid="header-logo-placeholder">
            RV
          </span>
        )}
      </span>
    </a>
  );
};
